import { get } from "lodash";
import { useCurrentTalent } from "@/features/talent/components/talent-scan-image/current-value/current-talent-context";
import {
  buildCurrentValueText,
  CurrentOptionsKey,
  CurrentValueType,
} from "@/features/talent/components/talent-scan-image/current-value/format-current-value";

// Returns the `現在の値：X` helper-text string for a given form field, or null
// when no helper should be rendered (e.g. modal opened from talent list without
// a CurrentTalentProvider, or the FormField did not declare a currentValueType).
//
// `name` is the react-hook-form field path (supports dot/bracket nesting via
// lodash.get), e.g. "fullName" or "workExperiences.0.companyName".
export const useCurrentValueDisplay = (
  name: string | undefined,
  type: CurrentValueType | undefined,
  optionsKey: CurrentOptionsKey | undefined,
): string | null => {
  const { currentTalent, options } = useCurrentTalent();

  if (!currentTalent || !name || !type) return null;

  const rawValue = get(currentTalent, name);
  const opts = optionsKey ? options[optionsKey] : undefined;
  return buildCurrentValueText(rawValue, type, opts);
};
